import { ColumnTotalVisibility } from '../TableColumn.interface';
export const TableTotalsSummaryService = {
    calculate: (column, rows) => {
        if (column.totalVisibility === ColumnTotalVisibility.None) {
            return NaN;
        }
        let sum = 0;
        for (const row of rows) {
            const value = row.data.getValue(column.id);
            if (isValidNumber(value)) {
                sum += value;
            }
        }
        return sum;
    },
    format: (_column, _rows, value) => {
        return isNaN(value) ? '' : value.toString();
    }
};
